// Aquí está el slice de activación de embajador
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  infoActivarEmbajador: null,
  failureActivarEmbajador: false,
  isLoadingActivarEmbajador: false,
  errorActivarEmbajador: null,
};

const activarEmbajadorSlice = createSlice({
  name: "activarEmbajador",
  initialState,
  reducers: {
    activarEmbajadorSuccess: (state, action) => {
      state.infoActivarEmbajador = action.payload.info;
      state.failureActivarEmbajador = false;
      state.isLoadingActivarEmbajador = false;
    },
    activarEmbajadorFailure: (state, action) => {
      state.failureActivarEmbajador = true;
      state.isLoadingActivarEmbajador = false;
      state.errorActivarEmbajador = action.payload; // mensaje de errorActivarEmbajador
    },
    activarEmbajadorReset: (state) => {
      state.infoActivarEmbajador = null;
      state.failureActivarEmbajador = false;
      state.errorActivarEmbajador = null;
      state.isLoadingActivarEmbajador = false;
    },
    setInfoEmbajador: (state, action) => {
      state.infoActivarEmbajador = action.payload;
    }
  },
});


export const {
  activarEmbajadorSuccess,
  activarEmbajadorFailure,
  activarEmbajadorReset,
  setInfoEmbajador,
} = activarEmbajadorSlice.actions;
export default activarEmbajadorSlice.reducer;
